"use client";
import {
  LocalizationProvider,
  pickersInputBaseClasses,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  DatePicker as MuiDatePicker,
  type DatePickerProps as MuiDatePickerProps,
} from "@mui/x-date-pickers/DatePicker";
import { enGB } from "date-fns/locale";
import { type FocusEvent, type ReactNode } from "react";
import InfoAdornment from "@/components/common/formElements/library/InfoAdornment";
import { StyledAdornmentContainer, StyledDatePickerContainer } from "./styles";

export interface DatePickerProps extends MuiDatePickerProps {
  required?: boolean;
  error?: boolean;
  name?: string;
  helperText?: ReactNode;
  fullWidth?: boolean;
  onBlurField?: (event: FocusEvent<HTMLInputElement>) => void;
  tooltip?: ReactNode;
}

export default function DatePicker(props: DatePickerProps) {
  const {
    required = false,
    error = false,
    helperText,
    fullWidth = true,
    onBlurField,
    slotProps,
    tooltip,
    ...datePickerProps
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <StyledDatePickerContainer>
        <MuiDatePicker
          slotProps={{
            textField: {
              ...slotProps?.textField,
              variant: "outlined",
              required,
              error,
              helperText,
              onBlur: onBlurField,
              fullWidth,
              sx: {
                [`& .${pickersInputBaseClasses.root}`]: {
                  paddingRight: tooltip ? "40px" : "14px",
                },
              },
              slotProps: {
                input: {
                  label: undefined,
                },
                inputLabel: {
                  variant: "filled",
                },
              },
            },
            ...slotProps,
          }}
          {...datePickerProps}
        />
        {tooltip && (
          <StyledAdornmentContainer>
            <InfoAdornment tooltip={tooltip} />
          </StyledAdornmentContainer>
        )}
      </StyledDatePickerContainer>
    </LocalizationProvider>
  );
}
